import React, { useEffect, useState } from "react";
import GiftIcon from "../../../assets/img/icons/gift.gif";
import Celebrate from "../../../assets/img/icons/celebrate.gif";

const EventCountdown = ({ date, type }) => {
  const [daysLeft, setDaysLeft] = useState(null);

  const calculateDaysLeft = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize today

    const inputDate = new Date(date);
    inputDate.setFullYear(today.getFullYear());
    inputDate.setHours(0, 0, 0, 0); // normalize event date

    // if event already passed, set to next year
    if (inputDate < today) {
      inputDate.setFullYear(today.getFullYear() + 1);
    }

    const diffTime = inputDate - today;
    return Math.round(diffTime / (1000 * 60 * 60 * 24)); // round is safer here
  };

  useEffect(() => {
    setDaysLeft(calculateDaysLeft());

    // update daily at midnight
    const interval = setInterval(() => {
      setDaysLeft(calculateDaysLeft());
    }, 1000 * 60 * 60 * 24);

    return () => clearInterval(interval);
  }, [date]);

  if (daysLeft === null || daysLeft > 15) return null;

  return (
    <span className="mx-2">
      {/* Show gift only if not today */}
      {daysLeft !== 0 && (
        <img src={GiftIcon} alt="gift icon" style={{ width: 30 }} />
      )}

      <span className="fw-semibold text-dark ms-2">
        {daysLeft === 0 ? (
          <span className="text-danger">
           Happy{" "}
            {type === "birthdate" ?  "Birthday" : "Anniversary"}{" "}
            <img src={GiftIcon} alt="gift icon" style={{ width: 30 }} />
            <img src={Celebrate} alt="gift icon" style={{ width: 30 }} />

          </span>
        ) : (
          `${daysLeft} days left`
        )}
      </span>
    </span>
  );
};

export default EventCountdown;
